import { render, staticRenderFns } from "./ChildPrivacy.vue?vue&type=template&id=b8308178&"
import script from "./ChildPrivacy.vue?vue&type=script&lang=js&"
export * from "./ChildPrivacy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports